// initial state
// shape: [{ id, quantity }]
import Vue from "vue";

const state = {
    settings: [

        {
            type: "vehicle",
            icon: "mdi-car",
            title: "Vehicle",
            parameters: [{ label: "Initial position [m]", ind: 0, min: -300, max: 0, step: 1 }, { label: "Speed [m/s]", ind: 1, min: 0, max: 62 / 3.6, step: .1 }]
        },
        {
            type: "bicycle",
            icon: "mdi-bike",
            title: "Bicycle",
            parameters: [{ label: "Initial position [m]", ind: 0, min: 0, max: 100, step: 1 }, { label: "Speed [m/s]", ind: 1, min: -10, max: 0, step: .1 }]
        },
        {
            type: "simulation",
            icon: "mdi-cogs",
            title: "Simulation",
            parameters: [{ label: "Wall lateral position [m]", ind: 0, min: 0, max: 30, step: 0.1 }, { label: "Time step [s]", ind: 1, min: 0.01, max: 1, step: 0.01 }, { label: "Duration [s]", ind: 2, min: 0.1, max: 20, step: 0.1 }]
        },
        {
            type: "driverModel",
            icon: "mdi-account-circle",
            title: "Driver model",
            parameters: [{ label: "Kex", ind: 0, min: 0, max: 5, step: 0.01 }, { label: "kex", ind: 1, min: 0, max: 5, step: 0.01 }, { label: "gate_ex", ind: 2, min: 0, max: 5, step: 0.01 }, { label: "Kin", ind: 3, min: 0, max: 5, step: 0.01 }, { label: "kin", ind: 4, min: 0, max: 5, step: 0.01 }]
        }
    ]
}

// getters
const getters = {

}

// actions
const actions = {

}

// mutations
const mutations = {

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

